"use client";

import { cn } from "@/lib/utils";

export type VoiceVisualizerProps = {
  isActive: boolean;
  agentName: string;
  avatarUrl: string;
};

export default function VoiceVisualizer({
  isActive,
  agentName,
  avatarUrl,
}: VoiceVisualizerProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6 px-4">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-[#e99bad]">{agentName}</h3>
        <p className="mt-1 text-sm text-gray-400">お話しください...</p>
      </div>

      <div className="relative flex h-48 w-48 items-center justify-center">
        <div
          className={cn(
            "absolute inset-0 rounded-full bg-[#e99bad]/10 transition-transform duration-700",
            isActive && "animate-ping"
          )}
        />
        <div
          className={cn(
            "absolute inset-3 rounded-full bg-[#e99bad]/5 transition-transform duration-500",
            isActive && "animate-pulse"
          )}
        />

        <div className="relative flex h-32 w-32 items-center justify-center overflow-hidden rounded-full border-4 border-white bg-gradient-to-br from-[#e99bad] to-[#f4c6d2] shadow-lg">
          <img
            src={avatarUrl}
            alt={agentName}
            className="absolute inset-0 h-full w-full object-cover opacity-30 mix-blend-overlay"
          />

          <div className="relative z-10 flex items-end gap-[3px]">
            {[0, 1, 2, 3, 4].map((i) => (
              <span
                key={i}
                className={cn(
                  "w-[3px] rounded-full bg-white transition-all",
                  isActive
                    ? "animate-voice-bar"
                    : "h-2"
                )}
                style={
                  isActive
                    ? {
                        animationDelay: `${i * 0.15}s`,
                        animationDuration: "0.6s",
                      }
                    : undefined
                }
              />
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes voice-bar {
          0%,
          100% {
            height: 8px;
          }
          50% {
            height: 28px;
          }
        }
        .animate-voice-bar {
          animation-name: voice-bar;
          animation-timing-function: ease-in-out;
          animation-iteration-count: infinite;
        }
      `}</style>
    </div>
  );
}
